import { EventEmitter } from '@angular/core';
import { ThemeConfig } from '../../../core/helpers/theme-config';
import { CombinedFacets } from '../../../facets/models/facet';
var isTileOrderable = ThemeConfig.get('catalog', 'is-tile-orderable');
var ProductListComponent = /** @class */ (function () {
    function ProductListComponent() {
        this.onDetails = new EventEmitter();
        this.onAddCart = new EventEmitter();
        this.onFavoriteToggle = new EventEmitter();
    }
    Object.defineProperty(ProductListComponent.prototype, "isTileOrderable", {
        get: function () {
            return isTileOrderable;
        },
        enumerable: true,
        configurable: true
    });
    ProductListComponent.prototype.cartProduct = function (product) {
        return this.cartProducts[product._id];
    };
    ProductListComponent.prototype.openDetails = function (event) {
        this.onDetails.emit(event);
    };
    ProductListComponent.prototype.isFavorite = function (product) {
        if (product && this.favoritesProducts)
            return !!this.favoritesProducts.find(function (item) { return product.code === item.productCode; });
        return false;
    };
    ProductListComponent.prototype.toggleFavorite = function (e) {
        this.onFavoriteToggle.emit(e);
    };
    ProductListComponent.prototype.addCart = function (event) {
        this.onAddCart.emit(event);
    };
    return ProductListComponent;
}());
export { ProductListComponent };
